<template>
    <div class="ft-fail">
        <div class="title">您的手机号已购买以下课程</div>
        <div class="course-name">《{{courseName}}》</div>
        <div class="tips">您可选择更换手机号或申请退款</div>
        <div class="foot">
            <button class="btn cancel" @click="$emit('on-click', {code:'cancel'})">申请退款</button>
            <button class="btn submit" @click="$emit('on-click', {code:'submit'})">更换手机</button>
        </div>
    </div>
</template>

<script>
import courseName from './index.js'

export default {
    props: {
        courseId: {
            type: [Number, String],
            default: () => ''
        }
    },
    computed: {
        courseName() {
            return this.courseId ? courseName[this.courseId] : '没有该课程'
        }
    },
}
</script>

<style lang="less" scoped>
.ft-fail {
    padding: 40px;
    .title {
        line-height: 1;
        color: #292118;
        font-size: 36px;
        font-weight: 600;
        text-align: center;
    }
    .course-name {
        line-height: 1;
        color: #7559ff;
        font-size: 36px;
        font-weight: 600;
        text-align: center;
        margin-top: 26px;
    }
    .tips {
        text-align: center;
        margin-top: 68px;
    }
    .foot {
        display: flex;
        margin-top: 66px;
        .btn {
            flex: 1;
            height: 80px;
            font-size: 28px;
            font-weight: 500;
            border: 0;
            border-radius: 40px;
        }
        .btn+ .btn {
            margin-left: 26px;
        }
    }
    .cancel {
        background: #f4f4f4;
    }
    .submit {
        background: #7559ff;
        color: #fff;
    }
}
</style>